export enum LockStateEnum {
  Locked = 0,
  Unlocked = 1,
}
export enum LockHistoryStateEnum {
  Lock = 0,
  Unlock = 1,
  Extend = 2,
}
